var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2LeaderboardCongratsChevron(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 61,
    height: 77.53,
    viewBox: "0 0 61 77.53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.91742 19.3786L61 0V73.4029L0 77.53L31.4642 49.8979L9.91742 19.3786Z",
    fill: "url(#paint0_linear_0_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 0,
    y1: 38.765,
    x2: 61,
    y2: 38.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CBF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120133,
    stopColor: "#2F9105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312452,
    stopColor: "#4AAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524002,
    stopColor: "#53BA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701897,
    stopColor: "#44A80A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884637,
    stopColor: "#2F9105"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2LeaderboardCongratsChevron);
export default __webpack_public_path__ + "static/media/v2_leaderboard_congrats_chevron.6c958ec6feac216a61109ae149adf73f.svg";
export { ForwardRef as ReactComponent };